import http from "../http-common";

const formDataRequestConfig = {
  transformRequest: [
    (payload, h) => {
      if (payload instanceof FormData && h && typeof h === "object") {
        delete h["Content-Type"];
        delete h["content-type"];
        delete h["Content-type"];
      }
      return payload;
    },
  ],
};

const getLatest = () => {
  return http.get("/apk");
};

const getVersions = () => {
  return http.get("/apk/versions");
};

const upload = (file, version) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("version", version);
  return http.post("/apk/upload", formData, formDataRequestConfig);
};

export const ApkService = {
  getLatest,
  getVersions,
  upload,
};
